import { Message, MessageAndIdModel } from "../../../domain/model/Auth";
import { Category } from "../../../domain/model/Category";
import {
  GetRandomQuestionRequestModel,
  Question,
} from "../../../domain/model/Question";
import { Response } from "../../api/Response";
import NetworkApi from "../../network/NetworkApi";
import { QuestionRepository } from "./QuestionRepository";

export class QuestionRepositoryImpl implements QuestionRepository {
  apiService: NetworkApi;

  constructor(datasource: NetworkApi) {
    this.apiService = datasource;
  }
  getRandomQuestion(
    getRandomQuestionRequestModel: GetRandomQuestionRequestModel,
  ): Promise<Response<Question>> {
    return this.apiService.getRandomQuestion(getRandomQuestionRequestModel);
  }
  giveAnswer(
    questionId: string,
    isCorrect: boolean,
  ): Promise<Response<Message>> {
    return this.apiService.giveAnswer(questionId, isCorrect,);
  }
}
